// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveAreaEducationAgencyDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AreaEducationAgencyDTO from '../models/AreaEducationAgencyDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    areaEducationAgencyId: string | null | null;
    areaEducationAgency: AreaEducationAgencyDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            areaEducationAgencyId: null,
            areaEducationAgency: null,
        },
        initValues);
    },
    areaEducationAgencyId: 'areaEducationAgencyId',
    areaEducationAgency: 'areaEducationAgency',
}

interface Result extends ResultDTO {
    areaEducationAgency: AreaEducationAgencyDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            areaEducationAgency: null,
        },
        initValues);
    },
    areaEducationAgency: 'areaEducationAgency',
}

export { Request, Result };